import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";

const BoxWrapperstyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 35px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .topContent": {
    marginBottom: "30px",
    "& h4": { fontSize: "22px", marginBottom: "8px", color: theme.palette.text.primary, fontWeight: 600 },
    "& p": { fontSize: "16px", marginBottom: "8px", color: theme.palette.text.primary },
  },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      transition: "all 0.3s ease-in-out",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        color: "#fff",
        transform: "scale(1.05)",
      },
      "&:focus": {
        outline: "none",
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        border: `2px solid ${theme.palette.primary.main}`,
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#fff",
        },
      },
    },
  },
}));

export default function ConfirmationPopup({ open, setOpen, onSubmit, isDowngrade, show, isUpgrade }) {
  const handleClose = () => setOpen(false);
  const handleUpdate = async () => {
    setOpen(false);
    onSubmit();
  };

  const isYearlyToMonthly = !show;

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }}>
      <Fade in={open}>
        <BoxWrapperstyle>
          <Box className="topContent">
            <Typography component="h4">
              {isUpgrade ? "Confirm Upgrade" : isYearlyToMonthly ? "Switching to Monthly Plan" : isDowngrade ? "Confirm Downgrade" : "Confirm Plan Change"}
            </Typography>

            <Typography component="p">
              {isUpgrade
                ? "You are upgrading your plan. Your remaining crawl credits from the previous subscription will be carried over to the new plan."
                : isYearlyToMonthly
                ? "You're switching from a yearly to a monthly plan. This will downgrade your current subscription. Are you sure you want to continue?"
                : isDowngrade
                ? "Your plan will be downgraded, but your current credits will remain active until this billing cycle ends. The new plan will only apply from the next billing cycle. Are you sure you want to continue?"
                : "You are updating your subscription plan."}
            </Typography>
          </Box>
          <Box className="BtnWrapper">
            <Button onClick={handleUpdate}>Confirm</Button>
            <Button className="OutlineBtn" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </BoxWrapperstyle>
      </Fade>
    </Modal>
  );
}
